module.exports = "/static/media/sms_enrollment_campaign.94da81a4.png";